import { useContext } from 'react';
import ProductsContext from 'contexts/ProductsContext';
import { Product } from 'types/app.types';
import { TileViewProvider } from 'contexts/TileViewContext';
import styles from './index.module.scss';
import FloatingWindowsSystem from '../../FloatingWindowsSystem';
import SingleTileView from './ components/SingleTileView';
import { FloatingWindowsProvider } from '../../../../../../../../../contexts/FloatingWindowsContext';

const { wrapper, productWindow, grid } = styles;

function TileView() {
  const { selectedProducts } = useContext(ProductsContext);

  return (
    <FloatingWindowsProvider>
      <TileViewProvider>
        <FloatingWindowsSystem mode="tile" />
        <div className={`${wrapper} ${selectedProducts.length === 4 ? grid : ''}`}>
          {selectedProducts.map((product : Product, index) => (
            <SingleTileView
              className={productWindow}
              product={product}
              // eslint-disable-next-line react/no-array-index-key
              key={product.id}
            />
          ))}
        </div>
      </TileViewProvider>
    </FloatingWindowsProvider>
  );
}

export default TileView;
